import axios from "axios";

import Config from "@/Config";
import { JWT_KEY } from "@/constants/api";

const AUTH_REDIRECT_KEY = "auth_redirect_url";

const axiosInstance = axios.create({
  baseURL: Config.BACKEND_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  Config.getAxiosConfig().interceptors.request,
  Config.getAxiosConfig().interceptors.error
);
axiosInstance.interceptors.response.use(
  Config.getAxiosConfig().interceptors.response,
  (error: any) => {
    // Handle loading state from the original error interceptor
    if (!error.config?.skipLoading) {
      const { triggerLoading } = require("@/utils/loadingManager");
      triggerLoading(false);
    }

    // On 401, save current URL and redirect to login
    if (error.response?.status === 401) {
      const { pathname, search } = window.location;
      const basePath = "/surfr-ui";
      const relativePath = pathname.startsWith(basePath)
        ? pathname.slice(basePath.length)
        : pathname;
      const fullPath = search ? `${relativePath}${search}` : relativePath;

      if (relativePath !== "/login") {
        sessionStorage.setItem(AUTH_REDIRECT_KEY, fullPath);
        localStorage.removeItem(JWT_KEY);
        window.location.href = `${basePath}/login`;
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
